import {Container} from 'react-bootstrap';

const PublicContainer = (props) => {
  return <Container {...props} />;
};

export default PublicContainer;
